export default __webpack_public_path__ + "static/media/Online_Privacy_Policy.88cb640d.pdf";